import { jsx as o } from "react/jsx-runtime";
import { createContext as r, useEffect as n } from "react";
import '../assets/index.css';const d = r(null), u = ({
  children: e,
  theme: t = "light"
}) => (n(() => {
  document && document.body.setAttribute("data-theme", `default-${t}`);
}, [t]), /* @__PURE__ */ o(d.Provider, { value: "", children: e }));
export {
  d as ThemeContext,
  u as ThemeProvider
};
